import { DICT } from '../utils/dict';
import Filters from '../utils/filters';
import download from '../utils/download';
import CdnFile from '../utils/cdn_file';

let userInfo = '';
// 路由队列
const hashRouter = [];
// 记录跳转前hash
let beforeHash = '';

// 注册hash 组件
function RegisterReactHashRouter({ name, node, ele, hash, hashPrefix = '#model=' }) {
  if (!hashRouter) {
    return false;
  }

  if (hashRouter.find(item => item.hash === hash)) {
    window.console.log(`重复注册 hash ${hash}, name ${name}`);
  }
  hashRouter.push({
    name,
    node,
    ele,
    hash: `${hashPrefix}${hash}`,
  });
}

function linkBlank(url) {
  let a = document.createElement('a');
  const newUrl = `${location.protocol || 'http:'}${process.env.UNION_DOMAIN_WITH_PREFIX}${url}`;
  a.href = newUrl;
  a.target = '_blank';
  a.click();
  a = null;
}


window.RegisterReactHashRouter = RegisterReactHashRouter;

// 触发hash 挂载组件，卸载组件
function triggerReactHashRouter() {
  const hash = location.hash;

  const Render = hashRouter.find(item => hash.includes(item.hash));
  const BeforeRender = hashRouter.find(item => beforeHash.includes(item.hash));
  if (BeforeRender && beforeHash && beforeHash !== hash) {
    window.console.log(`unmount component ${BeforeRender.name}`);
    ReactDOM.unmountComponentAtNode(BeforeRender.ele);
  }
  if (Render && hash) {
    window.console.log(`render component ${Render.name}`);
    ReactDOM.render(Render.node, Render.ele);
  }

  beforeHash = hash;
}

function listenHash() {
  beforeHash = location.hash;
  triggerReactHashRouter();
  window.addEventListener('hashchange', triggerReactHashRouter);
}

// 导航条完善。
$(() => {
  $('.header-nav-item').removeClass('active');
  $('#user').addClass('active');
  $('#admin_console').addClass('active');
});

$(() => {
  $(window).on(DICT.EVENT.WEBSITE_GET_USERINFO_FAIL, () => {
    location.href = process.env.WEBSITE_WEB_PREFIX;
  });
  $(window).on(DICT.EVENT.WEBSITE_TOKEN_EMPTY, () => {
    location.href = process.env.WEBSITE_WEB_PREFIX;
  });
});

// 个人中心的每一个小的导航的处理。
$(() => {
  // 用户角色先隐藏向上箭头
  $('.user-sidebar-left-title-identity-icon.fa-angle-up').hide();
  function matchUrlActive() {
    $('.js-right-group').hide();
    const regVal = new RegExp('(^|&)model=([^&]*)(&|$)');
    let resVal = window.location.hash.slice(1).match(regVal) ? window.location.hash.slice(1).match(regVal)[2] : '';
    const resVals = resVal.split('?');
    if (1 < resVals.length) {
      resVal = resVals[0];
    }
    $('.user-sidebar-left-list').children().removeClass('active');
    switch (resVal) {
      case 'app':
        $('.js-app-group').show();
        $('.js-app').addClass('active');
        checkSystem();
        break;
      case 'msg':
        $('.js-msg-group').show();
        $('.js-msg').addClass('active');
        break;
      case 'setting':
        $('.js-data-group').show();
        $('.js-setting').addClass('active');
        break;
      case 'school':
        $('.js-school-group').show();
        $('.js-school').addClass('active');
        break;
      case 'phone':
        $('.user-right-group-tel-1').show();
        $('.js-setting').addClass('active');
        break;
      case 'password':
        $('.js-pwd-group').show();
        $('.js-setting').addClass('active');
        break;
      case 'data':
        $('.user-right-group-setting').show();
        $('.js-setting').addClass('active');
        break;
      case 'announcement':
        $('.js-announcement-group').show();
        $('.js-announcement').addClass('active');
        break;
      case 'name':
        $('.js-name-group').show();
        $('.js-setting').addClass('active');
        break;
      case 'email':
        $('.js-email-group').show();
        $('.js-setting').addClass('active');
        break;
      default:
        $('.js-app-group').show();
        $('.js-app').addClass('active');
        break;
    }
  }
  $('.user-job').hide();
  $(window).on('hashchange', () => {
    $('.user-sidebar-left-list').children().removeClass('active');
    matchUrlActive();
  });
  matchUrlActive();
  $('.js-app').click(() => {
    window.location.hash = _.isEmpty(window.location.hash) ? 'model=app' : window.location.hash.replace(/model=([^&]*)/g, 'model=app');
  });
  $('.js-msg').click(() => {
    window.location.hash = _.isEmpty(window.location.hash) ? 'model=msg' : window.location.hash.replace(/model=([^&]*)/g, 'model=msg');
  });
  $('.js-setting').click(() => {
    window.location.hash = _.isEmpty(window.location.hash) ? 'model=setting' : window.location.hash.replace(/model=([^&]*)/g, 'model=setting');
  });
  $('.js-school').click(() => {
    window.location.hash = _.isEmpty(window.location.hash) ? 'model=school' : window.location.hash.replace(/model=([^&]*)/g, 'model=school');
  });
  $('.js-announcement').click(() => {
    // 显示列表
    if (window.announcementReact) {
      window.announcementReact.hideDetailView();
    }
    window.location.hash = _.isEmpty(window.location.hash) ? 'model=announcement' : window.location.hash.replace(/model=([^&]*)/g, 'model=announcement');
  });

  $('.js-support_document').click(() => {
    linkBlank('/website_support_document');
  });
  $('.js-my_question_answer').click(() => {
    linkBlank('/website_support_document/my_question');
  });
  $('.js-my_question').click(() => {
    linkBlank('/website_support_document/my_question/add');
  });
});

/**
 * 渲染个人信息
 */
function renderUserInfo(User) {
  $('.js-user-character').hide();
  $('.js-user-student').hide();
  $('.user-name').text(User.name || User.username);
  $('.user-area').text((_.get(User, 'city.name') || '') + (_.get(User, 'district.name') || ''));
  if (User.phone) {
    $('.user-phone').text(User.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'));
  }
  else {
    $('.user-phone').text('');
  }
  $('.user-department').text(_.get(User, 'department.name'));
  $('.user-mail').text(User.email || '');
  $('.user-sidebar-left-title-username-info').text(_.get(User, 'name') || _.get(User, 'username'));
  // 学生类型屏蔽手机和邮箱
  if (User.user_type === _.get(CONST_DICT, 'users.user_type.USER_TYPE_STUDENT')) {
    $('.js-user-phone').hide();
    $('.js-user-email').hide();
  }

  const dictUserType = _.get(CONST_DICT, 'users.user_type');
  const typeInfo = dictUserType.find((item) => {
    return item.value === User.user_type;
  });
  $('.user-right-group-data-head-type-text').text(_.get(typeInfo, 'label', ''));
  $('.user-right-group-data-head-type-select-only').text(_.get(typeInfo, 'label', ''));

  let userRoleText;
  if ([
    // _.get(CONST_DICT, 'users.user_type.USER_TYPE_SUPER'),
    _.get(CONST_DICT, 'users.user_type.USER_TYPE_CITY'),
    _.get(CONST_DICT, 'users.user_type.USER_TYPE_DISTRICT'),
    _.get(CONST_DICT, 'users.user_type.USER_TYPE_SCHOOL'),
    _.get(CONST_DICT, 'users.user_type.USER_TYPE_CITY_STAFF'),
    _.get(CONST_DICT, 'users.user_type.USER_TYPE_DISTRICT_STAFF'),
    _.get(CONST_DICT, 'users.user_type.USER_TYPE_SCHOOL_STAFF'),
  ].includes(1 * User.user_type)) {
    $('.js-user-character').show();
    const userRoles = _.map(_.get(User, 'user_roles') || [], 'name');
    if (userRoles && userRoles.length) {
      $('.user-character').text(userRoles.join(',\n'));
    }
    else {
      $('.user-character').text(Filters.dict(['users', 'user_type'], User.user_type));
    }
    userRoleText = !_.isEmpty(userRoles) ? userRoles.join(',\n') : Filters.dict(['users', 'user_type'], User.user_type);
    if (1 >= userRoles.length) {
      $('.user-sidebar-left-title-identity-icon').hide();
    }
  }
  else {
    userRoleText = Filters.dict(['users', 'user_type'], User.user_type);
    $('.user-sidebar-left-title-identity-icon').hide();
  }
  $('.user-sidebar-left-title-identity-icon.fa-angle-down').on('click', () => {
    $('.user-sidebar-left-title-identity').css({
      height: 'auto',
    });
    $('.user-sidebar-left-title-identity-icon.fa-angle-down').hide();
    $('.user-sidebar-left-title-identity-icon.fa-angle-up').show();
  });
  $('.user-sidebar-left-title-identity-icon.fa-angle-up').on('click', () => {
    $('.user-sidebar-left-title-identity').css({
      height: '16px',
    });
    $('.user-sidebar-left-title-identity-icon.fa-angle-up').hide();
    $('.user-sidebar-left-title-identity-icon.fa-angle-down').show();
  });
  $('.user-sidebar-left-title-identity-text').text(userRoleText);
  switch (1 * User.user_type) {
    case _.get(CONST_DICT, 'users.user_type.USER_TYPE_SUPER'):
    case _.get(CONST_DICT, 'users.user_type.USER_TYPE_CITY'):
    case _.get(CONST_DICT, 'users.user_type.USER_TYPE_DISTRICT'):
    case _.get(CONST_DICT, 'users.user_type.USER_TYPE_SCHOOL'):
      $('.js-user-phone').hide();
      $('.js-user-socialites').hide();
      break;
    case _.get(CONST_DICT, 'users.user_type.USER_TYPE_TEACHER'):
      $('.js-user-department>.user-right-group-data-item-title').text('学校');
      break;
    case _.get(CONST_DICT, 'users.user_type.USER_TYPE_STUDENT'):
      $('.user-student').text(_.get(User, 'student.student_no'));
      $('.js-user-student').show();
      $('.js-user-phone').hide();
      break;
    case _.get(CONST_DICT, 'users.user_type.USER_TYPE_PARENT'):
      $('.js-user-department').hide();
      break;
    default:
      break;
  }
}

/**
 * 渲染个人应用
 */
function renderApp(options) {
  const systemId = options.systemId;

  const query = Qs.parse(window.location.search.replace(/^\?/, ''));

  const formData = {
    // ...options, // 这个没啥卵用的，但是不知道为啥旧的代码会传这个。虽然我写了，但是我只是掉。
    to: options.link,
    post: options.post ? 'true' : 'false',
    system_id: systemId,
  }
  if (query.forceHttp) {
    formData.forceHttp = true;
  }

  const searchStr = Qs.stringify(formData);

  let protocol = 'http:';
  // 如果是张掖，就写死算了。
  if (0 <= `${options.link}`.indexOf('www.zyzhjyy.cn')) {
    protocol = 'https:';
  }

  if (query.forceHttp) {
    protocol = 'http:';
  }

  const jumpLink = `${protocol}//${location.hostname}${(process.env.WEBSITE_WEB_PREFIX || '').replace(/\/$/, '')}/jump_auto_login?${searchStr}`;

  const target = -1 < location.href.indexOf('debug') ? '_self' : '_blank';

  const temp = `
    <div class="col-lg-4 user-application-page-content-item-container" systemId=${options.systemId} style="display: none;">
      <div class="user-application-page-content-item">
        <img class="user-application-page-content-item-img" src=${options.icon} />
        <span class="user-application-page-content-item-name">${options.title}</span>
        <a class="user-application-page-content-item-link" data-bak-href="${options.link}" href="${jumpLink}" rel="noopener noreferrer" target="${target}" systemId="${options.systemId}" ${options.post ? 'post' : ''}>进入</a>
      </div>
    </div>
  `;
  return temp;
}

/**
 * 判断权限是否渲染
 */
function isRenderApp(elem, User, userRoles) {
  if (userRoles.includes(elem.attr('systemId'))) {
    elem.show();
  }
  else {
    elem.hide();
  }
  if ([
    _.get(CONST_DICT, 'users.user_type.USER_TYPE_SUPER'),
  ].includes(User.user_type)) {
    elem.show();
  }
}

$(window).on(DICT.EVENT.RENDER_APP, () => {
  checkSystem();
});

function checkSystem() {
  const userRoles = [];
  _.each(_.get(userInfo, 'user_roles'), (item) => {
    userRoles.push(`${_.get(item, 'system_id')}`);
  });
  // console.log('userInfo', userInfo, 'userRoles', userRoles);
  $('.user-application-page-content-item-container').each((index, elem) => {
    isRenderApp($(elem), userInfo, userRoles);
  });
  $('.user-sidebar-right-app-row').each((index, elem) => {
    $(elem).show();
    if (1 > $('.user-application-page-content-item-container:not(:hidden)', elem).length) {
      $(elem).hide();
    }
  });
}

/**
 * 获取应用列表
 */
function renderAppList() {
  $.ajax({
    url: `${DICT.API_DOMAIN_WITH_PREFIX}/system_category`,
    type: 'GET',
    success: (res) => {
      let module = '';
      const postList = [];
      _.each(_.get(res, 'data.data'), (item) => {
        let appList = '';
        _.each(_.get(item, 'systems'), (elem) => {
          // 只渲染 pc 端的系统
          if (elem.app_type !== _.get(CONST_DICT, 'systems.app_type.APP_TYPE_PC')) {
            return;
          }

          appList += renderApp({
            systemId: elem.id,
            icon: CdnFile(elem.icon),
            title: elem.name,
            link: elem.link,
            post: DICT.METHOD.POST === elem.method,
          });
          postList.push({
            ...elem,
          });
        });
        module += `<div class="row user-sidebar-right-app-row"><h3 class="col-lg-12 user-sidebar-right-app-title">${item.name}</h3>${appList}</div>`;
      });

      $('.js-app-group').append(module);
      // 这里的跳转有问题，需要进行特殊新页面进行post
      // 这些是需要 post 过去的一些操作。
      $('.user-application-page-content-item-link').on('click', (e) => {
        // 强行跳走，这个代码目前不用了。
        if (e) {
          return;
        }
        if (e && e.preventDefault) {
          e.preventDefault();
        }
        // 阻止人人通跳转 start
        // const $self = $(e.target);
        // const id = $self.attr('systemid') * 1;
        // if (300 < id && 400 > id) {
        //   // eslint-disable-next-line no-alert
        //   window.alert('人人通空间及资源应用系统正在维护，暂停使用，具体上线时间等待通知。');
        //   return;
        // }
        // 阻止人人通跳转 end

        let tokenData = '';

        try {
          tokenData = $.cookie(DICT.TOKEN_KEY);
        }
        catch (err) {
          tokenData = '';
        }

        const href = $(e.target).attr('href');
        const systemId = $(e.target).attr('systemId') * 1;
        const postData = _.find(postList, (item) => {
          return item.id === systemId;
        });
        let redirectUrl = `${DICT.API_DOMAIN_WITH_PREFIX}/user/redirect`;
        // let protocol = location.protocol;
        // if (0 > `${href}`.indexOf(location.hostname)) {
        //   protocol = 'http:';
        // }
        // redirectUrl = redirectUrl.replace(/^(https:)?\/\//, `${protocol}//`);
        redirectUrl = redirectUrl.replace(/^(https:)?\/\//, `${location.protocol}//`);
        download(redirectUrl, {
          api_token: tokenData,
          to: href,
          system_id: systemId,
          ...postData,
        }, {
          method: 'POST',
          target: -1 < location.href.indexOf('debug') ? '_self' : '_blank',
        });

        return false;
      });
      // 这里的跳转有问题，需要进行特殊新页面进行post end

      $(window).trigger(DICT.EVENT.RENDER_APP);
    },
    error: (rej) => {
      // eslint-disable-next-line no-console
      console.log(rej);
    },
  });
}

$(() => {
  renderAppList();
});

$(() => {
  // // 张掖的临时解决证书问题。
  // $(window).on(DICT.EVENT.WEBSITE_GET_USERINFO, (e, User) => {
  //   if ('https:' === location.protocol) {
  //     if (0 > location.host.indexOf(':')) {
  //       location.href = location.href.replace(/^https/, 'http');
  //     }
  //   }
  // });

  $(window).on(DICT.EVENT.WEBSITE_GET_USERINFO, (e, User) => {
    userInfo = User;
    renderUserInfo(User);
    $(window).trigger(DICT.EVENT.RENDER_APP);
    if (!_.get(window, '____User')) {
      // eslint-disable-next-line no-underscore-dangle
      window.____User = User;
    }
    listenHash();
  });

  /**
   * 修改密码
   */
  $('.password-change-form').on('submit', (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    // window.e = e;
    const $form = $(e.target);
    const valueArr = $form.serializeArray();
    const formData = {};
    _.each(valueArr, (elem) => {
      formData[elem.name] = elem.value;
    });
    if (formData.new_password !== formData.new_password_confirmation) {
      antd.notification.error({
        message: '两次密码输入不一致，请重试',
        key: 1,
        description: '',
        duration: 10,
      });
      return;
    }

    delete formData.new_password_confirmation;

    const passwordSubmitErr = (rej) => {
      const title = _.get(rej, 'msg') || '密码修改失败';

      antd.notification.error({
        message: title,
        key: 1,
        description: '',
        duration: 10,
      });
    };

    const passwordSubmitSuccess = (res) => {
      antd.message.success('密码修改成功');
      setTimeout(() => {
        window.location.hash = window.location.hash.replace(/model=([^&]*)/g, 'model=setting');
        $form.trigger('reset');
      }, 1000);
      window.console.log('res', res);
    };

    $.ajax({
      url: `${DICT.API_DOMAIN_WITH_PREFIX}/user/password`,
      type: 'PUT',
      data: JSON.stringify(formData),
      success: (res) => {
        if (0 === _.get(res, 'code')) {
          passwordSubmitSuccess(res);
        }
        else {
          passwordSubmitErr(res);
        }
      },
      error: (rej) => {
        passwordSubmitErr(rej);
      },
    });

    return false;
  });
  $('.user-right-group-pwd-btn-cancel').click(() => {
    $('.password-change-form').find('input').val('');
    window.location.hash = window.location.hash.replace(/model=([^&]*)/g, 'model=setting');
  });
});

$(() => {
  $(window).on(DICT.EVENT.WEBSITE_GET_USER_TYPE, (e, userTypes) => {
    // userInfo = User;
    renderUserType(userTypes);
  });

  // 显示用户类型下拉框
  $('.user-right-group-data-head-type-select').click(() => {
    const $option = $('.user-right-group-data-head-type-option');
    const $mask = $('.user-option-mask');
    if ($option.is(':hidden')) {
      $option.show();
      $mask.show();
    }
    else {
      $option.hide();
      $mask.hide();
    }
  });

  // 用户类型选择
  $('.user-right-group-data-head-type-option').click((event) => {
    const text = $(event.target).text();
    const value = $(event.target).attr('data-value');
    if (!value && 0 !== value) {
      return;
    }
    if (text) {
      $('.user-right-group-data-head-type-text').text(text);
      $('.user-right-group-data-head-type-option').hide();
      $('.user-option-mask').hide();
      // 设置用户类型
      setUserType(value);
    }
  });

  $('.user-option-mask').click(() => {
    $('.user-option-mask').hide();
    $('.user-right-group-data-head-type-option').hide();
  });
});

$(() => {
  // 修改姓名
  $('.name-change-form').on('submit', (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const valueArr = $(e.target).serializeArray();
    const formData = {};
    _.each(valueArr, (elem) => {
      formData[elem.name] = elem.value;
    });
    $.ajax({
      url: `${DICT.API_DOMAIN_WITH_PREFIX}/user`,
      type: 'PUT',
      data: JSON.stringify(formData),
      success: (res) => {
        if (0 === res.code) {
          antd.message.success('姓名修改成功');
          goBackRefresh();
        }
        else {
          showErrorMsg(res, '姓名修改失败，请联系管理员');
        }
      },
      error: () => {
        antd.notification.error({
          message: '姓名修改失败，请联系管理员',
          key: 1,
          description: '',
          duration: 10,
        });
      },
    });
  });
  $('.user-right-group-name-btn-cancel').click(() => {
    $('.user-right-group-name-input').val('');
    window.location.hash = window.location.hash.replace(/model=([^&]*)/g, 'model=setting');
  });

  // 修改邮箱
  $('.email-change-form').on('submit', (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const valueArr = $(e.target).serializeArray();
    const formData = {};
    _.each(valueArr, (elem) => {
      formData[elem.name] = elem.value;
    });

    if (formData.emailCode) {
      formData.code = formData.emailCode;
      delete formData.emailCode;
    }
    $.ajax({
      url: `${DICT.API_DOMAIN_WITH_PREFIX}/user`,
      type: 'PUT',
      data: JSON.stringify(formData),
      success: (res) => {
        if (0 === res.code) {
          antd.message.success('邮箱修改成功');
          goBackRefresh();
        }
        else {
          showErrorMsg(res, '邮箱修改失败，请联系管理员');
        }
      },
      error: () => {
        antd.notification.error({
          message: '邮箱修改失败，请联系管理员',
          key: 1,
          description: '',
          duration: 10,
        });
      },
    });
  });
  $('.user-right-group-email-btn-cancel').click(() => {
    $('.email-change-form').find('input').val('');
    window.location.hash = window.location.hash.replace(/model=([^&]*)/g, 'model=setting');
  });

  // 获取验证码
  $('.user-right-group-email-code-btn-get-code').click(() => {
    const email = $('.user-right-group-email-input').val();
    if (!email) {
      antd.notification.error({
        message: '尚未填写邮箱',
        key: 1,
        description: '',
        duration: 10,
      });
      return false;
    }

    const param = {
      email,
    };
    getCode(param, $('.user-right-group-email-code-btn-get-code'), 'email');
  });

  // 修改手机号码
  $('.phone-change-form').on('submit', (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const valueArr = $(e.target).serializeArray();
    const formData = {};
    _.each(valueArr, (elem) => {
      formData[elem.name] = elem.value;
    });

    if (formData.phoneCode) {
      formData.code = formData.phoneCode;
      delete formData.phoneCode;
    }
    $.ajax({
      url: `${DICT.API_DOMAIN_WITH_PREFIX}/user`,
      type: 'PUT',
      data: JSON.stringify(formData),
      success: (res) => {
        if (0 === res.code) {
          antd.message.success('手机号码修改成功');
          goBackRefresh();
        }
        else {
          showErrorMsg(res, '手机号码修改失败，请联系管理员');
        }
      },
      error: () => {
        antd.notification.error({
          message: '手机号码修改失败，请联系管理员',
          key: 1,
          description: '',
          duration: 10,
        });
      },
    });
  });
  $('.user-right-group-tel-progress-form-group-btn-cancel').click(() => {
    $('.phone-change-form').find('input').val('');
    window.location.hash = window.location.hash.replace(/model=([^&]*)/g, 'model=setting');
  });

  // 手机号码发送验证码
  $('.user-right-group-tel-code-btn-get-code').click(() => {
    const phone = $('.user-right-group-tel-progress-form-group-input').val();
    if (!phone) {
      antd.notification.error({
        message: '尚未填写手机号码',
        key: 1,
        description: '',
        duration: 10,
      });
      return false;
    }

    const param = {
      phone,
      type: 'change_phone',
    };
    getCode(param, $('.user-right-group-tel-code-btn-get-code'), 'phone');
  });
});

function showErrorMsg(res, normal) {
  let msg = normal;
  if (res.data && 0 < Object.keys(res.data).length) {
    const key = Object.keys(res.data)[0];
    msg = res.data[key];
  }
  else if (res.msg) {
    msg = res.msg;
  }

  antd.notification.error({
    message: msg,
    key: 1,
    description: '',
    duration: 10,
  });
}

function goBackRefresh() {
  setTimeout(() => {
    window.history.go(-1);
  }, 1000);
  setTimeout(() => {
    window.location.reload();
  }, 2000);
}

function getCode(param, $button, type) {
  $button.attr('disabled', true);
  $.ajax({
    url: `${DICT.API_DOMAIN_WITH_PREFIX}/${type}/code`,
    type: 'POST',
    data: JSON.stringify(param),
    success: (res) => {
      if (0 === res.code) {
        antd.message.success('验证码已发送，请注意查收');
        countdown($button);
      }
      else {
        $button.attr('disabled', false);
        showErrorMsg(res, '验证码发送失败，请联系管理员');
      }
    },
    error: () => {
      $button.attr('disabled', false);
      antd.notification.error({
        message: '验证码发送失败，请联系管理员',
        key: 1,
        description: '',
        duration: 10,
      });
    },
  });
}

function countdown($button) {
  let second = 60;

  const timer = setInterval(() => {
    $button.text(second -= 1);
    if (0 === second) {
      clearInterval(timer);
      $button.attr('disabled', false);
      $button.text('获取验证码');
    }
  }, 1000);
}
function setUserType(type) {
  let callbackHref = window.location.href;
  callbackHref = callbackHref.replace(/#*?&*?ctrl_d=([\d-]+)/ig, '').replace(/#$/ig, '').replace(/\?$/ig, '');
  callbackHref = callbackHref.replace(/#*?&*?ticket=(.*)/ig, '').replace(/#$/ig, '').replace(/\?$/ig, '');
  // eslint-disable-next-line camelcase
  const redirect_uri = encodeURIComponent(callbackHref);
  // eslint-disable-next-line camelcase
  const jumpUrl = `${DICT.API_DOMAIN_WITH_PREFIX}/switch_user_type?user_type=${type}&redirect_uri=${redirect_uri}`;
  console.log('jumpUrl', jumpUrl);
  antd.message.success('正在切换，请稍后');
  sessionStorage.clear();
  window.location.replace(jumpUrl);
}

function renderUserType(typeList) {
  const currentUserType = userInfo.user_type;
  let itemOption = '';
  let currentList = [];
  if (!_.isEmpty(typeList) && _.isArray(typeList)) {
    currentList = typeList.filter(item => item && item.value);
    itemOption = currentList.map((item) => {
      return `<div class='item ${currentUserType === item.value ? 'active' : ''}' data-value=${item.value}>${item.label}</div>`;
    }).join('');
  }
  if (1 === currentList.length || 0 === currentList.length) {
    $('.user-right-group-data-head-type-select').hide();
    $('.user-right-group-data-head-type-select-only').show();
  }
  else {
    $('.user-right-group-data-head-type-select').show();
    $('.user-right-group-data-head-type-select-only').hide();
  }

  $('.user-right-group-data-head-type-option').append(itemOption);
}

function getSocialites(res) {
  const { data } = res;
  const callbackHref = `${location.protocol || 'http:'}${process.env.UNION_DOMAIN_WITH_PREFIX}/website/user`;
  const wechatUrl = '/openLogin/wechat_auth_redirect';
  const qqUrl = '/openLogin/qq_auth_redirect';
  const wechat = data.find((item) => {
    return _.get(CONST_DICT, 'socialites.type.TYPE_WECHAT') === _.get(item, 'type', undefined);
  });
  const qq = data.find((item) => {
    return _.get(CONST_DICT, 'socialites.type.TYPE_QQ') === _.get(item, 'type', undefined);
  });

  if (wechat) {
    $('.wechat-untied').show();
    $('.wechat-binding').hide();
  }
  $('.wechat-binding').click(() => {
    if ('false' === process.env.IS_SHOW_SOCIALITES_WECHAT) {
      return;
    }
    window.location.replace(`${process.env.OPENAPI_DOMAIN_WITH_PREFIX}${wechatUrl}?redirect_uri=${callbackHref}`);
  });
  if (qq) {
    $('.qq-untied').show();
    $('.qq-binding').hide();
  }
  $('.qq-binding').click(() => {
    if ('false' === process.env.IS_SHOW_SOCIALITES_QQ) {
      return;
    }
    window.location.replace(`${process.env.OPENAPI_DOMAIN_WITH_PREFIX}${qqUrl}?redirect_uri=${callbackHref}`);
  });
  $('.wechat-untied').on('click', () => {
    if ('false' === process.env.IS_SHOW_SOCIALITES_WECHAT) {
      return;
    }
    $.ajax({
      url: `${DICT.API_DOMAIN_WITH_PREFIX}/user/socialites/${_.get(wechat, 'type')}`,
      type: 'DELETE',
      success: () => {
        $('.wechat-binding').show();
        $('.wechat-untied').hide();
      },
    });
  });
  $('.qq-untied').on('click', () => {
    if ('false' === process.env.IS_SHOW_SOCIALITES_QQ) {
      return;
    }
    $.ajax({
      url: `${DICT.API_DOMAIN_WITH_PREFIX}/user/socialites/${_.get(qq, 'type')}`,
      type: 'DELETE',
      success: () => {
        $('.qq-binding').show();
        $('.qq-untied').hide();
      },
    });
  });
}

$(() => {
  $('.wechat-untied').hide();
  $('.qq-untied').hide();
  $.ajax({
    url: `${DICT.API_DOMAIN_WITH_PREFIX}/user/socialites`,
    type: 'GET',
    success: (res) => {
      getSocialites(res);
    },
    error: (rej) => {
      // eslint-disable-next-line no-console
      console.log(rej);
    },
  });
});
